import axios from "../utils/axios";

export const trainingCatalogService = {
  fetchAll: async (status, params) => {
    try {
      const response = await axios.get(`/training-catalog/${status}`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching training catalogs:", error);
      throw error;
    }
  },

  fetchById: async (id, status) => {
    try {
      const response = await axios.get(`/training-catalog/${status}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching training catalog ${id}:`, error);
      throw error;
    }
  },

  verify: async (id) => {
    try {
      const response = await axios.post(
        `/training-catalog/status/${id}/accept`
      );
      return response.data;
    } catch (error) {
      console.error(`Error verifying training catalog ${id}:`, error);
      throw error;
    }
  },

  reject: async (id, reason) => {
    try {
      const response = await axios.post(
        `/training-catalog/status/${id}/reject`,
        {
          rejectReason: reason,
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Error rejecting training catalog ${id}:`, error);
      throw error;
    }
  },

  fetchByParticipantId: async (id) => {
    try {
      const response = await axios.get(`/training-catalog/accepted/member/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching participant ${id}:`, error);
      throw error;
    }
  },

  exportExcel: async (status, params = {}) => {
    const response = await axios.get(`/training-catalog/${status}/export-excel`, {
      params,
      responseType: "blob",
    });
    return response;
  },

  fetchStatusCounts: async () => {
    try {
      const response = await axios.get("/training-catalog/status-counts");
      return response.data;
    } catch (error) {
      console.error("Error fetching training catalog status counts:", error);
      throw error;
    }
  },

  exportAcceptedParticipantsExcel: async (catalogId) => {
    const response = await axios.get(
      `/training-catalog/accepted/${catalogId}/export-excel`,
      {
        responseType: "blob",
      }
    );
    return response;
  },
};

export default trainingCatalogService;
